import { Box, Grid } from '@material-ui/core';
import errorIcon from './../../../../../assets/error_icon.svg';
import styles from '../SGSNotification.module.scss';
import moment from 'moment';
import classNames from 'classnames';
export const radiation = (currentNotification) => {
    return (
        <>
            <Box className="text-center mt-3">
                <img src={errorIcon} alt="userBadge" className={styles.userBadge} />
            </Box>
            <Box className={styles.error_msg}>Oups, une erreur est survenue...</Box>
            {currentNotification?.content?.affilie?.prenom ? (
                <Grid container spacing={1} className={styles.identification}>
                    <Grid item xs={2} className="">
                        Assuré :
                    </Grid>
                    <Grid item xs={10} className={styles.identification_content}>
                        {currentNotification?.content?.affilie?.prenom} {currentNotification?.content?.affilie?.nom}
                    </Grid>
                    <Grid item xs={2} className="">
                        Souscripteur :
                    </Grid>
                    <Grid item xs={10} className={styles.identification_content}>
                        {currentNotification?.content?.souscrip?.nom}
                    </Grid>
                </Grid>
            ) : (
                <Box className={classNames('text-center')}>Une erreur technique s'est produite !</Box>
            )}

            <Grid container spacing={1} className="mt-5">
                {currentNotification?.content?.subscriptions.map((c) => {
                    const isValid = c.etat === 'Valide';
                    return (
                        <>
                            <Grid item xs={3} className={styles.light}>
                                Contrat : <span className={styles.dark}>{c.contrat}</span>
                            </Grid>
                            <Grid item xs={2} className={styles.light}>
                                Risque : <span className={styles.dark}> {c.typ === 'S' ? 'Santé' : 'Prévoyance'}</span>
                            </Grid>
                            <Grid item xs={2} className={styles.light}>
                                Etat : <span className={isValid ? styles.dark : styles.error}>{c.etat}</span>
                            </Grid>
                            <Grid item xs={5} className={styles.dark}>
                                <span className={styles.error}>{!isValid && c.libelle}</span>
                                {isValid && (
                                    <>
                                        <span className={styles.light}>Fin adhésion le : </span>
                                        {moment(c.dateFinAdhesion).format('DD/MM/YYYY')}
                                    </>
                                )}
                            </Grid>
                        </>
                    );
                })}
            </Grid>
        </>
    );
};
